import { useState } from "react";
import cx from "classnames";
import { BellIcon } from "@/components/Icon";
import Menu from "@/components/Menu";
import Badge from "@/components/Badge";
import styles from "./Header.module.scss";
import { useResponsive } from "@/hooks";
import { IconButton } from "@/components/Button";
import { NotificationPanel, MobileNotificationPanel } from "../Notification";
import { useNotificationStatisticsQuery } from "@/fetch/notifications";

const NotificationMenu: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
  const { isMobile } = useResponsive();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (isMobile) {
      console.log("here");
      setIsMobileMenuOpen(true);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  const { data: notificationStatistics } = useNotificationStatisticsQuery();
  const unseenNotificationsCount = notificationStatistics?.unseen || 0;

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={(event: any) => handleClick(event)}
        className={cx(styles.iconButton, {
          [styles.iconButtonWithBadge]: unseenNotificationsCount !== 0,
        })}
      >
        <Badge
          max={99}
          badgeContent={unseenNotificationsCount}
          hidden={unseenNotificationsCount === 0}
          color="error"
        >
          <BellIcon />
        </Badge>
      </IconButton>
      {isMobileMenuOpen && (
        <MobileNotificationPanel onExit={() => setIsMobileMenuOpen(false)} />
      )}
      <Menu
        elevation={3}
        id="notification-select-menu"
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleClose}
        classes={{
          list: styles.notificationMenuList,
          paper: styles.notificationMenuPaper,
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <NotificationPanel onExit={() => setAnchorEl(null)} />
      </Menu>
    </>
  );
};

export default NotificationMenu;
